module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-32x9-b5862f4e81a3f8ad42e6d063b6381113.jpg";